<template>
    <b-row>
      <b-col md="6">
        <b-card title="Titulos" >
        <b-table
            :striped="true"
            :bordered="true"
            :hover="true"
            :responsive="true"
            table-variant="secondary"
            :fields="fields"
            :items="$store.state.PTC_Dashboard.qtdTitulosDashboardPTC.titulos"
            show-empty
            empty-text="Nenhum registro encontrado"
        >
          <template #cell(index)="data">
            {{ data.index + 1 }}
          </template>

          <template #cell(tituloSituacao)="data">
            {{ formatarSituacao(data.value) }}
          </template>

          <template #cell(valorTotal)="data">
            {{ data.item.valorTotal | formtPriceBr }}
          </template>

          <template #cell(acoes)="data">
            <b-button
              variant="primary"
              size="sm"
              @click="redirecionarParaBoleto(data.item.tituloSituacao)"
            >
              Detalhes
            </b-button>
          </template>
        </b-table>
      </b-card>
      </b-col>
      <b-col md="6">
        <b-card title="Titulos">
         <apex-chart-ratio ref="atualizarGraficoTitulo" :option-data="option"  class="mt-4" />
        </b-card>
      </b-col>
    </b-row>
</template>

<script>
import ApexChartRatio from '@/views/app/PTC/DashBoard/analytics/apexChart/apexChartRatioTitulo.vue';
import { BCard, BCol, BRow } from 'bootstrap-vue';
import { mapGetters } from 'vuex';
import { formtPriceBr } from '@core/utils/filter';

export default {
  components: {
    ApexChartRatio,
    BCard,
    BCol,
    BRow,
  },
  filters: {
    formtPriceBr,
  },
  data() {
    return {
      fields: [
        { key: 'tituloSituacao', label: 'Situação', sortable: true },
        { key: 'Qtde', label: 'Qtde. Títulos', sortable: true },
        { key: 'valorTotal', label: 'Saldo Total', sortable: true },
        { key: 'acoes', label: 'Ações', sortable: true },
      ],
      option: {
        labels: [],
        series: [],
      },
    };
  },
  methods: {
    formatarSituacao(situacao) {
      if (!situacao) return '';

      const situacaoMap = {
        AVENCER: 'A Vencer',
        LIQUIDADO: 'Liquidado',
        LIQUIDADOPARCIAL: 'Liquidado Parcial',
        VENCIDO: 'Vencido',
      };

      return situacaoMap[situacao] || situacao;
    },
    async atualizarGraficoTitulo() {
      const rawLabels = JSON.parse(JSON.stringify(this.getLabelsTitulos));
      this.option.labels = rawLabels.map(l => this.formatarSituacao(l));
      this.option.series = await JSON.parse(JSON.stringify(this.getServersTitulos));
      this.$refs.atualizarGraficoTitulo.atualizarGfTitulo();
    },
    redirecionarParaBoleto(situacao) {
      this.$router.push({
        name: 'boleto',
        query: {
          situacao,
        },
      });
    },
  },
  computed: {
    ...mapGetters({
      getServersTitulos: 'PTC_Dashboard/getServersTitulos',
      getLabelsTitulos: 'PTC_Dashboard/getLabelsTitulos',
    }),
  },
};

</script>
<style scoped lang="scss">

</style>
